import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="footer" className="clearfix bg-footer2 pd-t81 re-hi">
      <div className="themesflat-container">
        <div className="row footer-top">
          <div className="col-lg-6 col-md-12 col-12 pd-r80">
            <h2 className="title-footer-top">
              Need a <span className="red-title">Car Rental</span> in Rajkot?
            </h2>
          </div>
        </div>
        <div className="row footer-main">
          <div className="col-lg-3 col-md-6 col-12">
            <div className="widget widget-info">
              <img
                src="/assets/images/logo/logo.png"
                style={{ maxWidth: '240px' }}
                alt="Cab Experience - Car Rental Rajkot Logo"
              />
              <p>
                Cab Experience is Rajkot's premier car rental service
                offering premium vehicles for all occasions. From weddings
                to outstation trips, we provide reliable and affordable car
                hire solutions with 24/7 service.
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-12">
            <div className="widget widget-menu pl-60">
              <h3>Quick Links</h3>
              <ul className="box-menu">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/swift-dzire">Our Cars</Link></li>
                <li><Link to="/book-a-car">Book A Car</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
                <li><a href="#">Terms & Conditions</a></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-12">
            <div className="widget widget-menu pl-30">
              <h3>Our Services</h3>
              <ul className="box-menu">
                <li><a href="#">Wedding Car Rental</a></li>
                <li><a href="#">Outstation Cab Service</a></li>
                <li><a href="#">Airport Transfer</a></li>
                <li><a href="#">Corporate Car Rental</a></li>
                <li><a href="#">City Tours</a></li>
                <li><a href="#">Monthly Car Rental</a></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-12">
            <div className="widget widget-menu widget-form">
              <h3>Contact us</h3>
              <ul>
                <li>
                  <i className="icon-Vector1"></i>
                  <p>Cab Experience, KKV Chowk Opp. St. Mary's Public School Kalawad Rd, Near KKV Hall, Rajkot, Gujarat, India</p>
                </li>
                <li>
                  <i className="icon-Group-1"></i>
                  <p>info@cabexperience.com</p>
                </li>
                <li>
                  <i className="icon-Group-11"></i>
                  <p>+91 7801904444</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row footer-bottom">
          <div className="col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
            <p className="coppy-right">
              Made by{' '}
              <a href="https://pixelprecisionweb.com/" target='_blank'>Pixel Precision Web</a>
            </p>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
            <ul className="social-icon">
              <li><a href="#"><i className="icon-6"></i></a></li>
              <li><a href="#"><i className="icon-4"></i></a></li>
              <li><a href="#"><i className="icon-5"></i></a></li>
              <li><a href="#"><i className="icon-7"></i></a></li>
            </ul>
          </div>
          <div className="col-md-12 col-lg-12 col-xl-4 col-xxl-4">
            <ul className="bottom-bar-menu">
              <li><a href="#">Terms & Conditions</a></li>
              <li><a href="#">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
      </div>
      {/* Mobile Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          .footer-main { padding: 40px 0 20px !important; }
          .widget { margin-bottom: 30px !important; }
          .widget h3 { font-size: 18px !important; margin-bottom: 15px !important; }
          .widget p { font-size: 14px !important; }
          .box-menu li { margin-bottom: 8px !important; }
          .box-menu a { font-size: 14px !important; }
          .social-icon { gap: 10px !important; }
          .social-icon a { width: 40px !important; height: 40px !important; }
          .footer-bottom { padding: 20px 0 !important; }
          .footer-bottom p { font-size: 13px !important; }
        }
        @media (max-width: 480px) {
          .widget h3 { font-size: 16px !important; }
          .footer-bottom { text-align: center !important; }
          .footer-bottom .row { flex-direction: column !important; gap: 10px !important; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
